import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface EvaluationLimitDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function EvaluationLimitDialog({ open, onOpenChange }: EvaluationLimitDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
            <AlertDialogTitle>Evaluation Limit Reached</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-left">
            You've reached your maximum limit of 1,000 evaluations. All your active tests have been automatically paused and cannot be reactivated until you upgrade your plan or your evaluations reset.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button onClick={() => onOpenChange(false)}>
            Understood
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}